export function pointAsArrayToObject(point: [longitude: number, latitude: number]): {
    longitude: number;
    latitude: number;
} {
    return { longitude: point[0], latitude: point[1] };
}
